import { useDrag } from 'react-dnd'
import { formatDate } from '../util/format'
import { useTranslation } from 'react-i18next'

const ToDoItem = ({ data, onPress }) => {
    const { t } = useTranslation()
    const [{ opacity }, drag] = useDrag(() => ({
        type: 'TODO_ITEM',
        item: {
            id: data.ID,
        },
        collect: (monitor) => ({
            opacity: monitor.isDragging() ? 0.3 : 1
        })
    }))


    return (
        <div
            className='todos-list-column-item'
            onClick={onPress}
            ref={drag}
            style={{ opacity }}
        >
            <div className='todos-list-column-item--content'>
                <h3>{data.TITLE}</h3>
                {
                    data.DUE_DATE && <span className='todos-list-column-item--due-date'>{`${t('Tähtaeg')}: ${formatDate(new Date(data.DUE_DATE))}`}</span>
                }
                {
                    data.assignee && <span className='todos-list-column-item--assignee'>Vastutav: {data.assignee?.RNAME}</span>
                }
            </div>
            <div className='todos-list-column-item--footer'>
                <span className='todos-list-column-item--author'>{data?.author?.RNAME}</span>
                <span className='todos-list-column-item--updated'>{`${t('Lisatud')}: ${formatDate(new Date(data.CREATED_AT))}`}</span>
            </div>
        </div>
    )
}

export default ToDoItem